import { getSagaWatcher, sendError } from '@utils';
import { alertsSagaWatcher } from 'seller/store/saga/alerts/saga';
import { notificationsSagaWatcher } from 'seller/store/saga/userNotifications/saga';
import { refundsSagaWatcher, searchProductsSagaWatcher } from './actions';
import { advertisingSagaWatcher } from './saga/advertising';
import { amazonTrafficSagaWatcher } from './saga/amazonTraffic';
import { billingSagaWatcher } from './saga/billing';
import { bookmarksSagaWatcher } from './saga/bookmarks';
import { dashboardSagaWatcher } from './saga/dashboard';
import { emailToolSagaWatcher } from './saga/emailTool';
import { expensesSagaWatcher } from './saga/expenses';
import { globalSystemNotificationSagaWatcher } from './saga/globalSystemNotification';
import { inventorySagaWatcher } from './saga/inventory';
import { loginSagaWatcher } from './saga/login';
import { monthlyBrandReviewSagaWatcher } from './saga/monthlyBrandReview';
import { ordersSagaWatcher } from './saga/orders';
import { pnlDashboardSagaWatcher } from './saga/pnlDashboard';
import { productsSagaWatcher } from './saga/products';
import { reportsSagaWatcher } from './saga/reports';
import { shopifySagaWatcher } from './saga/shopify';
import { systemSagaWatcher } from './saga/system';
import { userFeedbackSagaWatcher } from './saga/userFeedback';
import { userPreferencesSagaWatcher } from './saga/userPreferences';

const watchers = [
  refundsSagaWatcher,
  productsSagaWatcher,
  ordersSagaWatcher,
  bookmarksSagaWatcher,
  searchProductsSagaWatcher,
  dashboardSagaWatcher,
  emailToolSagaWatcher,
  userPreferencesSagaWatcher,
  inventorySagaWatcher,
  loginSagaWatcher,
  systemSagaWatcher,
  globalSystemNotificationSagaWatcher,
  reportsSagaWatcher,
  expensesSagaWatcher,
  amazonTrafficSagaWatcher,
  monthlyBrandReviewSagaWatcher,
  advertisingSagaWatcher,
  shopifySagaWatcher,
  pnlDashboardSagaWatcher,
  userFeedbackSagaWatcher,
  notificationsSagaWatcher,
  alertsSagaWatcher,
  billingSagaWatcher
];

const sagaWatcher = getSagaWatcher(watchers, sendError);

export default sagaWatcher;
